// extracted by mini-css-extract-plugin
export default {"section":"Faq_section__yTh+g","faqInner":"Faq_faqInner__niR26"};